import React from 'react';

/**
 * B2Bonix by WebPlace — brand logo.
 * Inline SVG icon (navy rounded square with a stylized "B" + connection nodes)
 * paired with the wordmark. `variant` controls text color for light/dark backgrounds.
 */
export const B2BonixLogo = ({
  variant = 'dark',
  showSubtitle = true,
  iconSize = 40,
  className = '',
  to = '/',
  asLink = true,
}) => {
  const textColor = variant === 'light' ? '#FFFFFF' : '#0F172A';
  const subColor = variant === 'light' ? 'rgba(255,255,255,0.65)' : '#64748B';

  const inner = (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="b2bonix-logo">
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="shrink-0"
      >
        <rect width="48" height="48" rx="12" fill="#1a224f" />
        {/* Stylized B */}
        <path
          d="M16 13h8.2c3.4 0 5.8 2 5.8 5.1 0 2-1 3.5-2.7 4.2 2.2.6 3.5 2.3 3.5 4.7 0 3.3-2.6 5.4-6.4 5.4H16V13Zm4.6 7.6h3c1.4 0 2.3-.8 2.3-2 0-1.2-.9-2-2.3-2h-3v4Zm0 8h3.3c1.5 0 2.5-.8 2.5-2.1s-1-2.1-2.5-2.1h-3.3v4.2Z"
          fill="#FFFFFF"
        />
        {/* Emerald connection node */}
        <circle cx="35" cy="14" r="3.2" fill="#10b981" />
      </svg>
      <span className="flex flex-col leading-none">
        <span
          className="font-display font-extrabold tracking-tight text-[19px]"
          style={{ color: textColor }}
        >
          B2B<span style={{ color: '#10b981' }}>onix</span>
        </span>
        {showSubtitle && (
          <span
            className="font-body text-[10px] font-medium tracking-wide mt-0.5"
            style={{ color: subColor }}
          >
            by WebPlace
          </span>
        )}
      </span>
    </span>
  );

  if (asLink) {
    return (
      <a href={to} className="inline-flex items-center no-underline">
        {inner}
      </a>
    );
  }
  return inner;
};

export default B2BonixLogo;
